module.exports = __webpack_public_path__ + "assets/Star0Icon.6c8c164666f545d9c3be05f8ac6fa8b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/stars/Star0Icon.svg
// module id = 49
// module chunks = 0